const env = process.env || {}; // eslint-disable-line no-process-env

[
  'NODE_ENV',
  'APP_PORT',
  'API_URL'
].forEach((name) => {
  if (!env[name]) {
    console.log(`Environment variable ${name} is missing, use default instead.`);
  }
});

const config = {
  ENV: env.NODE_ENV || 'development',
  staticURL: env.STATIC_URL || 'http://localhost:3000',
  API_URL: 'https://api.phuyentrade.gov.vn/api',
  PORT: Number(env.APP_PORT || 4000),
  UploadImageURL: env.UploadImageURL || 'https://img.phuyentrade.gov.vn',
  UploadImageURLDevelopment: env.UploadImageURLDevelopment || 'https://api.phuyentrade.gov.vn/api/containers',
  CAPTCHA_KEY: '6LfWmHIgAAAAAMgqL1if_Ik5R0CpKUTI524Bb47G',
  FB_ID: '186114358979294'
};

module.exports = config;



// WEBPACK FOOTER //
// ./constants/config.js